// extracted by mini-css-extract-plugin
export default {"root":"style_root__Sw_aE","tips":"style_tips__m48g7"};